import React, { useState } from 'react';
import AttachmentUpload from './AttachmentUpload';

const HotelForm = ({ onSave, onCancel, initialData }) => {
  const [formData, setFormData] = useState({
    title: initialData?.title || '',
    propertyName: initialData?.propertyName || '',
    location: initialData?.location || '',
    checkInDate: initialData?.checkInDate || '',
    checkInTime: initialData?.checkInTime || '',
    checkOutDate: initialData?.checkOutDate || '',
    checkOutTime: initialData?.checkOutTime || '',
    roomType: initialData?.roomType || '',
    confirmationNumber: initialData?.confirmationNumber || '',
    phoneNumber: initialData?.phoneNumber || '',
    description: initialData?.description || '',
    price: initialData?.price || '',
    depositRequired: initialData?.depositRequired || false,
    depositAmount: initialData?.depositAmount || '',
    depositDueDate: initialData?.depositDueDate || '',
    isOption: initialData?.isOption || false,
    optionDescription: initialData?.optionDescription || '',
    paymentTiming: initialData?.paymentTiming || 'with_deposit',
    optionalDepositAmount: initialData?.optionalDepositAmount || '',
    photos: initialData?.photos || [],
    documents: initialData?.documents || []
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      ...formData,
      price: parseFloat(formData.price) || 0,
      depositAmount: formData.depositRequired ? parseFloat(formData.depositAmount) || 0 : 0,
      paymentTiming: formData.paymentTiming,
      optionalDepositAmount: formData.optionalDepositAmount ? parseFloat(formData.optionalDepositAmount) : null
    });
  };

  return (
    <form onSubmit={handleSubmit} className="component-form hotel-form">
      <div className="form-section">
        <h4>Hotel Information</h4>
        
        <div className="form-group">
          <label>Title/Description*</label>
          <input
            type="text"
            value={formData.title}
            onChange={(e) => setFormData({...formData, title: e.target.value})}
            placeholder="e.g., 3 Nights at Hilton Paris"
            required
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Property Name*</label>
            <input
              type="text"
              value={formData.propertyName}
              onChange={(e) => setFormData({...formData, propertyName: e.target.value})}
              placeholder="e.g., Hilton Paris Opera"
              required
            />
          </div>
          <div className="form-group">
            <label>Location*</label>
            <input
              type="text"
              value={formData.location}
              onChange={(e) => setFormData({...formData, location: e.target.value})}
              placeholder="e.g., Paris, France"
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Check-in Date*</label>
            <input
              type="date"
              value={formData.checkInDate}
              onChange={(e) => setFormData({...formData, checkInDate: e.target.value})}
              required
            />
          </div>
          <div className="form-group">
            <label>Check-out Date*</label>
            <input
              type="date"
              value={formData.checkOutDate}
              onChange={(e) => setFormData({...formData, checkOutDate: e.target.value})}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Room Type</label>
            <input
              type="text"
              value={formData.roomType}
              onChange={(e) => setFormData({...formData, roomType: e.target.value})}
              placeholder="e.g., Deluxe King Room"
            />
          </div>
          <div className="form-group">
            <label>Price*</label>
            <input
              type="number"
              value={formData.price}
              onChange={(e) => setFormData({...formData, price: e.target.value})}
              placeholder="0.00"
              min="0"
              step="0.01"
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Confirmation Number</label>
            <input
              type="text"
              value={formData.confirmationNumber}
              onChange={(e) => setFormData({...formData, confirmationNumber: e.target.value})}
              placeholder="e.g., ABC123456"
            />
          </div>
          <div className="form-group">
            <label>Hotel Phone</label>
            <input
              type="tel"
              value={formData.phoneNumber}
              onChange={(e) => setFormData({...formData, phoneNumber: e.target.value})}
              placeholder="e.g., +33 1 42 86 83 42"
            />
          </div>
        </div>

        <div className="form-group">
          <label>Additional Description</label>
          <textarea
            value={formData.description}
            onChange={(e) => setFormData({...formData, description: e.target.value})}
            placeholder="Add any additional details about this hotel stay..."
            rows="3"
          />
        </div>
      </div>

      <div className="form-section">
        <h4>Deposit Information</h4>
        
        <div className="form-row">
          <div className="form-group">
            <label>
              <input
                type="checkbox"
                checked={formData.depositRequired}
                onChange={(e) => setFormData({...formData, depositRequired: e.target.checked})}
              />
              Deposit Required
            </label>
          </div>
        </div>

        {formData.depositRequired && (
          <div className="form-row">
            <div className="form-group">
              <label>Deposit Amount*</label>
              <input
                type="number"
                value={formData.depositAmount}
                onChange={(e) => setFormData({...formData, depositAmount: e.target.value})}
                placeholder="0.00"
                min="0"
                step="0.01"
                required
              />
            </div>
            <div className="form-group">
              <label>Deposit Due Date</label>
              <input
                type="date"
                value={formData.depositDueDate}
                onChange={(e) => setFormData({...formData, depositDueDate: e.target.value})}
              />
            </div>
          </div>
        )}
      </div>

      <div className="form-section">
        <h4>Client Options</h4>
        
        <div className="form-row">
          <div className="form-group">
            <label>
              <input
                type="checkbox"
                checked={formData.isOption}
                onChange={(e) => setFormData({...formData, isOption: e.target.checked})}
              />
              Mark as Optional for Client
            </label>
            <small className="form-help">
              When checked, clients can choose whether to include this component in their booking
            </small>
          </div>
        </div>

        {formData.isOption && (
          <>
            <div className="form-group">
              <label>Option Description for Client</label>
              <textarea
                value={formData.optionDescription}
                onChange={(e) => setFormData({...formData, optionDescription: e.target.value})}
                placeholder="e.g., Choose your preferred hotel accommodation level"
                rows="2"
              />
              <small className="form-help">
                This description helps clients understand what this option includes
              </small>
            </div>

            <div className="form-group">
              <label>Payment Timing for This Option</label>
              <select
                name="paymentTiming"
                value={formData.paymentTiming}
                onChange={(e) => setFormData({...formData, paymentTiming: e.target.value})}
                className="form-control"
              >
                <option value="immediate">Pay Immediately When Selected (Full Price)</option>
                <option value="with_deposit">Pay Deposit When Selected</option>
                <option value="with_final">Pay With Final Payment</option>
                <option value="bundled">Bundled (No Additional Payment)</option>
              </select>
              <small className="form-help">
                Controls when payment is due if client selects this option
              </small>
            </div>

            {formData.paymentTiming === 'with_deposit' && (
              <div className="form-group">
                <label>Deposit Amount for This Option ($)</label>
                <input
                  type="number"
                  name="optionalDepositAmount"
                  value={formData.optionalDepositAmount}
                  onChange={(e) => setFormData({...formData, optionalDepositAmount: e.target.value})}
                  step="0.01"
                  min="0"
                  className="form-control"
                  placeholder="0.00"
                />
                <small className="form-help">
                  Amount due immediately when client selects this option
                </small>
              </div>
            )}
          </>
        )}
      </div>

      <AttachmentUpload
        photos={formData.photos}
        documents={formData.documents}
        onPhotosChange={(photos) => setFormData({...formData, photos})}
        onDocumentsChange={(documents) => setFormData({...formData, documents})}
        maxPhotos={5}
        maxDocuments={3}
        showPhotos={true}
        showDocuments={true}
      />

      <div className="form-actions">
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="btn btn-primary">
          {initialData ? 'Update' : 'Add'} Hotel
        </button>
      </div>
    </form>
  );
};

export default HotelForm;
